import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_FUND_WALLET_OTP } from "../../../config/api";

export const fundWalletOTP = createAsyncThunk(
  "fundWallet/otp",
  async ({ id, callback, failed }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: `${API_FUND_WALLET_OTP}${id}`,
      });
      callback();
      return response?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed();
      return rejectWithValue(msg);
    }
  }
);
